import React, { useRef } from 'react';
import S2cTermsContent from 'Components/S2cTermsContent';
import Checkbox from 'SharedComponents/Checkbox';
import TermsWrapperLinks from 'Components/TermsWrapperLinks';
import { TermsWrapperElement } from 'SharedComponents/styled/forms/TermsWrapperElement';

interface TermsWrapperProps extends React.InputHTMLAttributes<HTMLInputElement> {
    isVisible: boolean;
    showError: boolean;
    usingRef: Function;
}

const TermsWrapper: React.FunctionComponent<TermsWrapperProps> = ({ showError, usingRef, isVisible, ...props }) => {
    const termsWrapperElementRef = useRef<HTMLDivElement>(null);

    if (!isVisible) {
        return <></>;
    }

    return (
        <TermsWrapperElement ref={termsWrapperElementRef}>
            <Checkbox
                name="agb"
                labelClassName={`qa-login-signup-form__terms ${showError ? 'qa-login-signup-form__terms-error' : ''}`}
                value="1"
                showError={showError}
                usingRef={usingRef}
                disabled={props.disabled}
                onChange={props.onChange}
                isTransparent={false}
            >
                <S2cTermsContent westwingPopContainerRef={termsWrapperElementRef} />
            </Checkbox>
            <TermsWrapperLinks />
        </TermsWrapperElement>
    );
};

export default TermsWrapper;
